import Vue from 'vue';
import './utils/appRunEnv'
import App from './App.vue';
import router from './router';
import store from './store';
// import VueLazyload from 'vue-lazyload';
// import '../mock';
import Vant from 'vant';
import 'vant/lib/index.css';
import 'animate.css';
import dayjs from 'dayjs';
/**
 * 引入各类三方文件
 */
import { importExternalCss, importExternalJs } from './utils/domUtil';
import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';

declare global {
  interface Window {
    stageENV: any;
  }
}

Vue.use(Vant);
Vue.use(VXETable);
const echarts = require('echarts');
Vue.prototype.$echarts = echarts;
Vue.prototype.$day = dayjs;
Vue.config.productionTip = false;
// import { initWeiXinSdkConfig } from './utils/jsConfig'

// 阿里 iconfon 引入
importExternalCss('//at.alicdn.com/t/font_669321_348ygp5i98k.css');

// 微信 sdk
importExternalJs('//res.wx.qq.com/open/js/jweixin-1.3.2.js')

const app: Vue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  mounted() {
    // initWeiXinSdkConfig()
  }
});

export default app;
